import React, { useEffect } from 'react';
import { SlideContainer } from './container';
import { SlideContent } from './content';
import { Text } from './text';
import { SlideProps } from '../Recap';
import RecapSlide from '../RecapSlide';
import TwoNonPlatinum from './giftCodes/TwoNonPlatinum';
import TwoPlatinum from './giftCodes/TwoPlatinum';
import OneOfEach from './giftCodes/OneOfEach';
import { asset } from '../../../utils/misc';

const primaryColor = '#813e73';
const secondaryColor = '#be87a8';

export const Slide5 = ({ current = false, scale, data, soundEnabled = false }: SlideProps) => {
    const musicUrl = asset('/dist/audio/recap-music-05.mp3');
    const soundUrl = asset('/dist/audio/typewriter.mp3');
    const [layout, setLayout] = React.useState<'two-non-platinum' | 'one-of-each' | 'two-platinum'>('two-non-platinum');
    const [primaryColor, setPrimaryColor] = React.useState('#813e73');
    const [secondaryColor, setSecondaryColor] = React.useState('#be87a8');
    const [primaryFont, setPrimaryFont] = React.useState<'basis' | 'plain' | 'maison-neue' | 'fifties-cond-med' | 'pp'>('fifties-cond-med');
    const [secondaryFont, setSecondaryFont] = React.useState<'basis' | 'plain' | 'maison-neue' | 'fifties-cond-med' | 'pp'>('fifties-cond-med');
    const [line1Props, setLine1Props] = React.useState<any>({});
    const [line2Props, setLine2Props] = React.useState<any>({});
    const [line3Props, setLine3Props] = React.useState<any>({});
    const [line4Props, setLine4Props] = React.useState<any>({});
    const [line5Props, setLine5Props] = React.useState<any>({});
    const [line6Props, setLine6Props] = React.useState<any>({});
    const [line7Props, setLine7Props] = React.useState<any>({});
    const [isPlayed, setIsPlayed] = React.useState(false);

    useEffect(() => {
        if (current) {
            setIsPlayed(true);
        }
    }, [current]);

    useEffect(() => {
        if (!data) return;

        if (data.gift_codes[0].platinum && data.gift_codes[1].platinum) {
            setLayout('two-platinum');
        } else if (!data.gift_codes[0].platinum && !data.gift_codes[1].platinum) {
            setLayout('two-non-platinum');
        } else {
            setLayout('one-of-each');
        }
    }, [data]);

    useEffect(() => {
        switch (layout) {
            case 'two-non-platinum':
            case 'one-of-each':
                setPrimaryColor('#813e73');
                setSecondaryColor('#be87a8');
                setPrimaryFont('fifties-cond-med');
                setSecondaryFont('maison-neue');
                setLine1Props({
                    fontSize: 28,
                    marginBottom: '-10px',
                });
                setLine2Props({
                    fontSize: 70,
                });
                setLine3Props({
                    fontSize: 40,
                });
                setLine4Props({
                    fontSize: 30,
                    marginBottom: '-10px',
                });
                setLine5Props({
                    fontSize: 38,
                    marginBottom: '-10px',
                });
                setLine6Props({
                    fontSize: 38,
                });
                setLine7Props({
                    fontSize: 5,
                });
                break;
            case 'two-platinum':
                setPrimaryColor('#d72e2e');
                setSecondaryColor('#63171a');
                setPrimaryFont('pp');
                setSecondaryFont('pp');
                setLine1Props({
                    fontSize: 14,
                    fontWeight: 700,
                });
                setLine2Props({
                    fontSize: 44,
                    fontWeight: 700,
                });
                setLine3Props({
                    fontSize: 20,
                    fontWeight: 700,
                });
                setLine4Props({
                    fontSize: 20,
                    fontWeight: 700,
                });
                setLine5Props({
                    fontSize: 20,
                    fontWeight: 700,
                });
                setLine6Props({
                    fontSize: 37,
                    fontWeight: 700,
                });
                setLine7Props({
                    fontSize: 5,
                });
                break;
        }
    }, [layout]);

    const codes = data && data.gift_codes ? data.gift_codes.slice(0, 2) : [
        {
            code: '123123123123',
            platinum: false
        },
        {
            code: '456456456456',
            platinum: false
        }
    ];

    const sizeFactor = 1.3;

    return (
        <RecapSlide animations={[
            ['line-1'],
            ['line-2', 'line-3'],
            ['line-4'],
            ['line-5'],
            ['line-6'],
            ['line-7'],
        ]} focus={current} soundEnabled={soundEnabled} musicUrl={musicUrl} soundUrl={soundUrl} playSoundOnce={true}>
            <SlideContainer>
                <SlideContent bg={secondaryColor} scale={scale}>
                    <Text className="overflow-h line-1" fontFamily={primaryFont} fontSize={`${line1Props.fontSize * sizeFactor}px`} fontWeight={line1Props.fontWeight || 400} color={primaryColor}
                        style={{
                            marginBottom: line1Props.marginBottom || 0
                        }}
                    >
                        <span className="anim anim-slide-from-top">Estas</span>
                        {' '}
                        <span className="anim anim-slide-from-top">fiestas</span>
                        {' '}
                        <span className="anim anim-slide-from-top">regala</span>
                    </Text>

                    <Text className="overflow-h line-2" fontFamily={primaryFont} fontSize={`${line2Props.fontSize * sizeFactor}px`} fontWeight={line2Props.fontWeight || 400} color={primaryColor} lineHeight='1'>
                        <span className="anim anim-slide-from-left">Cinemex</span>
                    </Text>

                    {'two-non-platinum' === layout && <TwoNonPlatinum
                        primaryColor={primaryColor}
                        secondaryColor={secondaryColor}
                        primaryFont={primaryFont}
                        secondaryFont={secondaryFont}
                        line3Props={line3Props}
                        sizeFactor={sizeFactor}
                        codes={codes}
                    />}

                    {'one-of-each' === layout && <OneOfEach
                        primaryColor={primaryColor}
                        secondaryColor={secondaryColor}
                        primaryFont={primaryFont}
                        secondaryFont={secondaryFont}
                        line3Props={line3Props}
                        sizeFactor={sizeFactor}
                        codes={codes}
                    />}

                    {'two-platinum' === layout && <TwoPlatinum
                        primaryColor={primaryColor}
                        secondaryColor={secondaryColor}
                        primaryFont={primaryFont}
                        secondaryFont={secondaryFont}
                        line3Props={line3Props}
                        sizeFactor={sizeFactor}
                        codes={codes}
                    />}

                    <Text className="overflow-h line-4" fontFamily={primaryFont} fontSize={`${line4Props.fontSize * sizeFactor}px`} fontWeight={line4Props.fontWeight || 400} color={primaryColor}
                        style={{
                            marginBottom: line4Props.marginBottom || 0,
                            height: '1em'
                        }}
                    >
                        <span className="anim anim-letters-from-left">+unas palomitas</span>
                    </Text>
                    <Text className="overflow-h line-5" fontFamily={primaryFont} fontSize={`${line5Props.fontSize * sizeFactor}px`} fontWeight={line5Props.fontWeight || 400} color={primaryColor}
                        style={{
                            marginBottom: line5Props.marginBottom || 0,
                            height: '1em'
                        }}
                    >
                        <span className="anim anim-letters-from-left">clásicas grandes</span>
                    </Text>
                    <Text className="overflow-h line-6" fontFamily={primaryFont} fontSize={`${line6Props.fontSize * sizeFactor}px`} fontWeight={line6Props.fontWeight || 400} color={primaryColor}
                        style={{
                            height: '1em'
                        }}
                    >
                        <span className="anim anim-letters-from-left">por $50</span>
                    </Text>

                    <Text className="line-7 anim anim-fade-in" fontFamily={secondaryFont} color={primaryColor}>
                        {'two-non-platinum' === layout && <>
                            <p className='text-uppercase mb-2' style={{fontSize: `${line7Props.fontSize * sizeFactor}px`}}>
                                Canjéalas en punto de venta en experiencia tradicional o market
                            </p>
                            <p className='mb-1' style={{fontSize: `${line7Props.fontSize * 0.8 * sizeFactor}px`}}>
                                Códigos: APLICA EN FORMATO 2D, solo se puede redimir por canal digital. NO APLICA EN SALAS IMAX®, ATMOS, 3D Y 4D. Aplica días festivos.
                                Sujeto a disponibilidad de las salas. No válido para: Wicked: For Good, Bugonia, Five Nights at Freddy's 2. Vigencia al 31/01/2026.
                            </p>
                            <p className='mb-0' style={{fontSize: `${line7Props.fontSize * 0.8 * sizeFactor}px`}}>
                                Palomitas clásicas sal grandes (100 g aprox) Redime presentando tu tarjeta Cinemex Loop. No aplica cambio de sabor ni refill.
                                Vigencia al 31/12/2026. No aplica con otras promociones o precios reducidos. Una redención por Looper. 
                            </p>
                        </>}

                        {'one-of-each' === layout && <>
                            <p className='text-uppercase mb-2' style={{fontSize: `${line7Props.fontSize * sizeFactor}px`}}>
                                canjéalas en punto de venta en experiencia tradicional o market
                            </p>
                            <p className='mb-1' style={{fontSize: `${line7Props.fontSize * 0.8 * sizeFactor}px`}}>
                                códigos: APLICA EN FORMATO 2D, solo se puede redimir por canal digital. NO APLICA EN SALAS IMAX®, ATMOS, 3D Y 4D. Aplica días festivos.
                                Sujeto a disponibilidad de las salas. No válido para: Wicked: For Good, Bugonia, Five Nights at Freddy's 2. Vigencia al 31/01/2026.
                            </p>
                            <p className='mb-0' style={{fontSize: `${line7Props.fontSize * 0.8 * sizeFactor}px`}}>
                                Palomitas clásicas sal grandes (100 g aprox) Redime presentando tu tarjeta Cinemex Loop. No aplica cambio de sabor ni refill.
                                Vigencia al 31/12/2026. No aplica con otras promociones o precios reducidos. Una redención por Looper. 
                            </p>
                        </>}

                        {'two-platinum' === layout && <>
                            <p className='text-uppercase mb-2' style={{fontSize: `${line7Props.fontSize * sizeFactor}px`, marginTop: '30px'}}>
                                Canjéalas en punto de venta en experiencia PLATINO
                            </p>
                            <p className='mb-1' style={{fontSize: `${line7Props.fontSize * 0.8 * sizeFactor}px`}}>
                                códigos: APLICA EN FORMATO 2D, solo se puede redimir por canal digital. NO APLICA EN SALAS IMAX®, ATMOS, 3D Y 4D. APLICA EN DÍAS FESTIVOS. 
                                LOS BOLETOS ESTAN SUJETOS A DISPONIBILIDAD DE LA SALAS, NO APLICA EN LOS SIGUIENTES TÍTULOS: Wicked: For Good, Bugonia, Five Nights at 
                                Freddy's 2. vigencia al 31 de enero de 2026.
                            </p>
                            <p className='mb-0' style={{fontSize: `${line7Props.fontSize * 0.8 * sizeFactor}px`}}>
                                Palomitas clásicas sal grandes (100 g aproximadamente) cargadas en tu tarjeta cinemex loop. No aplica cambio de sabor ni refill. 
                                Vigencia al 31 de enero de 2026. No aplica con otras promociones y/o precios reducidos. Es válido una redención por Looper. 
                            </p>
                        </>}
                    </Text>
                </SlideContent>
            </SlideContainer>
        </RecapSlide>
    );
};